<template>
  <div
    class="about-us por ova"
    :class="{
      en: $i18n.locale === 'en-US',
    }"
  >
    <div class="content">
      <div
        class="title-wrapper text-center wow animate__animated animate__fadeInUp"
      >
        <p class="section-title text-bold">{{ $t("home.aboutUs.title") }}</p>
        <p class="section-subtitle text-left">
          {{ $t("home.aboutUs.subtitle") }}
        </p>
      </div>
      <div
        class="content-main flex items-center wow animate__animated animate__fadeInUp"
      >
        <div class="video-wrapper">
          <video
            class="video"
            :src="$t('home.aboutUs.video')"
            controls
            muted
            autoplay
            loop
            x-webkit-airplay="allow"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
          ></video>
        </div>
        <div class="content-text flex-1 flex justify-center items-center">
          <div class="inner-text section-subtitle ova">
            {{ $t("home.aboutUs.detail") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bgImg from "@/static/img/home/about-us-bg.jpg";

export default {
  data() {
    return {
      bgImg,
    };
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>

<style scoped lang="scss">
.about-us {
  background-image: url("@/static/img/home/about-us-bg.jpg");
  .content {
    width: 100%;
    padding: 9.6rem 0 7rem;
    .title-wrapper {
      width: 57rem;
      margin: 0 auto 2.5rem;
      .section-title {
        margin-bottom: 1rem;
      }
    }
    .content-main {
      width: 71.841rem;
      height: 22.6719rem;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .video-wrapper {
        width: 0;
        min-width: 40.4rem;
        height: 100%;
        .video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          vertical-align: middle;
        }
      }
      .content-text {
        height: 100%;
        border-radius: 0 0.25rem 0.25rem 0;
        background: linear-gradient(
          141deg,
          rgba(62, 62, 133, 0.2) 19.92%,
          rgba(35, 36, 88, 0.2) 83.01%
        );
        box-shadow: 0 2rem 1.5rem 0 rgba(7, 10, 22, 0.25);
        backdrop-filter: blur(0.933rem);
        .inner-text {
          max-width: 25.2rem;
          max-height: 100%;
        }
      }
    }
  }

  &.en {
    .content {
      .title-wrapper {
        width: 70rem;
        .section-subtitle {
          line-height: 1.5rem;
        }
      }
    }
  }
}
</style>
